import { removeNamespace } from '../../utils/helpers'

export const LAYOUT_TYPES = {
  mutations: {
    SET_DRAWER: 'layout/SET_DRAWER'
  }
}

const _types = removeNamespace('layout', LAYOUT_TYPES)

const state = () => ({
  drawer: true
})

const getters = {}

const mutations = {
  [_types.mutations.SET_DRAWER] (state, drawer) {
    state.drawer = drawer
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
